/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Integration_Connect_Permission_DeniedInputs */

const en_integration_connect_permission_denied = /** @type {(inputs: Integration_Connect_Permission_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Listening was not given access to your ${i?.provider} files. Allow access and try connecting again.`)
};

const es_integration_connect_permission_denied = /** @type {(inputs: Integration_Connect_Permission_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Listening no recibió acceso a tus archivos de ${i?.provider}. Permite el acceso e intenta conectarte de nuevo.`)
};

/**
* | output |
* | --- |
* | "Listening was not given access to your {provider} files. Allow access and try connecting again." |
*
* @param {Integration_Connect_Permission_DeniedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const integration_connect_permission_denied = /** @type {((inputs: Integration_Connect_Permission_DeniedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_Connect_Permission_DeniedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_integration_connect_permission_denied(inputs)
	return en_integration_connect_permission_denied(inputs)
});